import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CustomButton from "../CustomButton";
import { RiChatPrivateLine } from "react-icons/ri";
import Denuncia from "../../assets/images/denuncia.jpg";
import "./ComplaintCall.css";

export default function ComplaintCall(props) {
  return (
    <Container className="complaint-call-section">
      <Row>
        <Col className="complaint-call-first-col">
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            <RiChatPrivateLine
              style={{ color: props.iconColor }}
              className="complaint-call-icon"
            />
            CANAL DE DENÚNCIAS
          </h2>
        </Col>
      </Row>
      <Row>
        <Col lg={6} className="complaint-call-third-col">
          <p style={{ color: props.textColor, fontSize: props.textSize }}>
            Faça por aqui uma denúncia totalmente anônima. A sua colaboração faz
            toda a diferença. Juntos criamos um ambiente de trabalho saudável e
            livre de discriminação, assédio e fraudes.
          </p>
          <CustomButton
            className="primary-btn"
            variant="primary"
            href="https://contatoseguro.com.br/grupo-krause"
            rel="noopener noreferrer"
            target="_blank"
            icon=""
            content="ACESSE O CANAL"
            backgroundColor={props.primaryBtnColor}
            fontFamily="Unageo-Bold"
            fontColor={props.white}
            fontSize={18}
            width={250}
            borderColor={props.primaryBtnColor}
            disabled={false}
          />
        </Col>
        <Col
          lg={{ span: 6, order: "first" }}
          className="complaint-call-second-col"
        >
          <div className="complaint-call-img-container">
            <img src={Denuncia} alt="Denuncia" />
            <div className="complaint-call-img-overlay" />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
